import moment from 'moment-timezone';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ResponsibleService } from './../../_services/responsible.service';


export interface DialogData {
  length: number;
  amount: number;
  user: any;
  type: string;
}

@Component({
  selector: 'app-responsible-confirm',
  templateUrl: './responsible-confirm.component.html',
  styleUrls: ['./responsible-confirm.component.scss']
})
export class ResponsibleConfirmComponent implements OnInit {

  up = '';
  warning = '';
  loading = false;

  constructor(public dialogRef: MatDialogRef<ResponsibleConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private _responsibleService: ResponsibleService) { }

  ngOnInit() {
  }

  closeWithout() {
    this.dialogRef.close();
  }

  submitExclusion(event = null) {
    if (event != null && event.keyCode != null && event.keyCode != 13) return false;
    this.loading = true;
    this._responsibleService.voluntaryExclusion(this.data.user.id, this.data.length, this.up).subscribe(res => {
      //handle api response here
      if (res.status == "success") {
        //close window
        this.dialogRef.close({ status: "success", message: "Voluntary Exclusion activated for " + this.data.length + " days." });
      } else {
        //set warning string
        this.warning = res.message;
      }
      this.loading = false;
    });
  }

  submitDepositLimit(event = null) {
    if (event != null && event.keyCode != null && event.keyCode != 13) return false;
    this.loading = true;
    this._responsibleService.depositLimit(this.data.user.id, this.data.amount, this.data.length, this.up).subscribe(res => {
      //handle api response here
      if (res.status == "success") {
        //close window
        this.dialogRef.close({ status: "success", message: "Deposit Limit of $" + this.data.amount + " set for " + this.data.length + " days." });
      } else {
        //set warning string
        this.warning = res.message;
      }
      this.loading = false;
    });
  }

  getDate() {
    // this.data.length == number of days
    return moment().add(this.data.length, 'days').format('dddd, MMMM Do YYYY');
  }

}
